export default __webpack_public_path__ + "static/media/GW.8b5feec7.svg";